import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_PathwayTransition = {
    _v1: {
        updateResolutionFunction: {
            method: HttpMethod.POST,
            path: 'v1/pathway-transition/update-resolution-function',
            timeout: Minute
        },
        deleteResolutionFunction: { method: HttpMethod.POST, path: 'v1/pathway-transition/delete-resolution-function' },
        updateTransitionsPriority: { method: HttpMethod.POST, path: 'v1/pathway-transition/update-transitions-priority' },
        deletePathwayTransition: { method: HttpMethod.POST, path: 'v1/pathway-transition/delete-transition' },
        detachTransitionContext: { method: HttpMethod.POST, path: 'v1/pathway-transition/detach-transition-context' },
        copyTransition: { method: HttpMethod.POST, path: 'v1/pathway-transition/copy-transition' },
        copyTransitionOrders: { method: HttpMethod.POST, path: 'v1/pathway-transition/copy-transition-orders' },
    }
};
//# sourceMappingURL=api-def.js.map